import { useState } from 'react';

import { Delete02Icon, File01Icon, Upload05Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import { useDropzone } from 'react-dropzone';

import { Loader } from 'components/Loader/Loader';

import styles from './FileContentsPicker.module.scss';

export const FileContentsPicker = ({
  className,
  maxSize = 20971520,
  accept,
  onChange = () => {},
}) => {
  const [fileName, setFileName] = useState();
  const [loading, setLoading] = useState(false);

  /**
   * --- On upload ---
   * 1) Get file meta
   * 2) Sign upload
   * 3) Upload to s3
   * 4) Create upload
   * 5) Set value
   */
  const onDrop = async files => {
    if (files.length < 1) return;

    setLoading(true);

    const file = files[0];
    const reader = new FileReader();
    reader.onload = e => {
      setFileName(file.name);
      onChange(e.target.result);
    };
    reader.readAsDataURL(file);
    setLoading(false);
  };

  const onRemove = async () => {
    setFileName(null);
    onChange(null);
    setLoading(false);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept, maxSize });

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center min-h-[10em] bg-neutral-2 border border-dashed border-neutral-4 rounded-3xl shadow-sm px-8 py-16',
        { [className]: className },
      )}>
      {loading && <Loader />}

      {fileName && !loading && (
        <div className={styles.fileWrapper}>
          <HugeiconsIcon icon={File01Icon} size={40} />
          <p>{fileName}</p>
          <div className={styles.removeFileIconWrapper} onClick={onRemove}>
            <HugeiconsIcon className={styles.removeFileIcon} icon={Delete02Icon} size={50} />
          </div>
        </div>
      )}

      {!fileName && !loading && (
        <div {...getRootProps({ className: styles.dropzone })}>
          <input {...getInputProps()} />
          <HugeiconsIcon icon={Upload05Icon} size={48} strokeWidth="1" className="text-primary-4" />
          <p className="text-neutral-6 font-regular mt-4">
            Drop your documents here, or <span className="text-primary-4 dark">browse</span>
          </p>
        </div>
      )}
    </div>
  );
};
